var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-xs-12" }, [
        _c("div", { staticClass: "card" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "card__content" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-xs-12" }, [
                _c("div", { staticClass: "table-responsive" }, [
                  _c("table", [
                    _c("tbody", [
                      _c("tr", [
                        _vm._m(2),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(_vm.comprobante.tipo_comprobante.descripcion)
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "tr",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.comprobante.id_tipo_comprobante !== "00",
                              expression:
                                "comprobante.id_tipo_comprobante !== '00'"
                            }
                          ]
                        },
                        [
                          _vm._m(3),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(_vm._s(_vm.comprobante.numero_documento))
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "tr",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.comprobante.id_tipo_comprobante === "00",
                              expression:
                                "comprobante.id_tipo_comprobante === '00'"
                            }
                          ]
                        },
                        [
                          _vm._m(4),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(_vm._s(_vm.comprobante.numero_proforma))
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(5),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(_vm.comprobante.fecha_emision_comprobante)
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "tr",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.comprobante.id_tipo_comprobante !== "00",
                              expression:
                                "comprobante.id_tipo_comprobante !== '00'"
                            }
                          ]
                        },
                        [
                          _vm._m(6),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(_vm.comprobante.tipo_emision.descripcion)
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "tr",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.comprobante.id_tipo_comprobante !== "00",
                              expression:
                                "comprobante.id_tipo_comprobante !== '00'"
                            }
                          ]
                        },
                        [
                          _vm._m(7),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(_vm._s(_vm.comprobante.clave_acceso))
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "tr",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.comprobante.id_tipo_comprobante !== "00",
                              expression:
                                "comprobante.id_tipo_comprobante !== '00'"
                            }
                          ]
                        },
                        [
                          _vm._m(8),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.comprobante.fecha_autorizacion_comprobante
                              )
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "tr",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.comprobante.id_tipo_comprobante !== "00",
                              expression:
                                "comprobante.id_tipo_comprobante !== '00'"
                            }
                          ]
                        },
                        [
                          _vm._m(9),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(_vm._s(_vm.comprobante.numero_autorizacion))
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(10),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(_vm.comprobante.nombre_cliente))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(11),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(_vm.comprobante.numero_identificacion))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(12),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(_vm.comprobante.correo_cliente))
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "tr",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.comprobante.valor_total !== null,
                              expression: "comprobante.valor_total !== null"
                            }
                          ]
                        },
                        [
                          _vm._m(13),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "$ " +
                                _vm._s(
                                  parseFloat(
                                    _vm.comprobante.valor_total
                                  ).toLocaleString(_vm.locale)
                                )
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "tr",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.comprobante.id_tipo_comprobante !== "00",
                              expression:
                                "comprobante.id_tipo_comprobante !== '00'"
                            }
                          ]
                        },
                        [
                          _vm._m(14),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.comprobante.estado_comprobante !== null
                                  ? _vm.comprobante.estado_comprobante
                                      .descripcion
                                  : "Emitido"
                              )
                            )
                          ])
                        ]
                      )
                    ])
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.comprobante.id_estado_comprobante === "AUT" &&
                      _vm.comprobante.intento_correo,
                    expression:
                      "comprobante.id_estado_comprobante === 'AUT' && comprobante.intento_correo"
                  }
                ],
                staticClass: "row center-xs"
              },
              [
                _c("div", { staticClass: "col-xs-12" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn-info",
                      attrs: { type: "button" },
                      on: { click: _vm.enviarCorreo }
                    },
                    [
                      _c("i", { staticClass: "fa fa-envelope-o" }),
                      _vm._v(" "),
                      _c("span", [_vm._v("Re-enviar correo electrónico")])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "btn-success",
                      attrs: {
                        target: "_blank",
                        href:
                          _vm.url +
                          "/comprobantes?tipo_comprobante=" +
                          _vm.comprobante.id_tipo_comprobante +
                          "&id_comprobante=" +
                          _vm.comprobante.id_comprobante
                      }
                    },
                    [
                      _c("i", { staticClass: "fa fa-edit" }),
                      _vm._v(" "),
                      _c("span", [_vm._v("Ver comprobante")])
                    ]
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "row center-xs" }, [
              _c("div", { staticClass: "col-xs-12" }, [
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.comprobante.path_generado !== null,
                        expression: "comprobante.path_generado !== null"
                      }
                    ],
                    staticClass: "btn-info btn--text",
                    attrs: {
                      target: "_blank",
                      href:
                        _vm.url +
                        "/xml/" +
                        _vm.comprobante.id_comprobante +
                        "/generado"
                    }
                  },
                  [
                    _c("i", { staticClass: "fa fa-file-excel-o" }),
                    _c("span", [_vm._v("Ver XML")])
                  ]
                )
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12" }, [
        _c("br"),
        _vm._v(" "),
        _c("div", { staticClass: "card" }, [
          _vm._m(15),
          _vm._v(" "),
          _c("div", { staticClass: "card__content" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-xs-12" }, [
                _c("div", { staticClass: "table-responsive" }, [
                  _c("table", [
                    _vm._m(16),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      [
                        _c(
                          "tr",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.comprobante.respuestas.length === 0,
                                expression:
                                  "comprobante.respuestas.length === 0"
                              }
                            ]
                          },
                          [_vm._m(17)]
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.comprobante.respuestas, function(
                          evento,
                          index
                        ) {
                          return _c("tr", { key: index }, [
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  evento.tipo_ambiente !== null
                                    ? evento.tipo_ambiente.descripcion
                                    : "-"
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(evento.fecha))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(evento.respuesta))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(evento.tipo))]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(_vm._s(evento.informacion_adicional))
                            ]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(evento.identificador))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(evento.estado))])
                          ])
                        })
                      ],
                      2
                    )
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout" }, [
      _c("div", { staticClass: "layout__header" }, [
        _c("div", { staticClass: "layout__title" }, [
          _c("h3", [_vm._v("Comprobante electrónico")])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Información del comprobante")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Tipo de comprobante")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Número de documento")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Número de documento")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Fecha de emisión")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Tipo de emisión")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Clave de acceso")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Fecha de autorización")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Número de autorización")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Cliente")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Número de identificación")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Correo del cliente")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Total del comprobante")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Estado del comprobante")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Logs")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Tipo de ambiente")]),
        _vm._v(" "),
        _c("th", [_vm._v("Fecha")]),
        _vm._v(" "),
        _c("th", [_vm._v("Respuesta")]),
        _vm._v(" "),
        _c("th", [_vm._v("Tipo de evento")]),
        _vm._v(" "),
        _c("th", [_vm._v("Información adicional")]),
        _vm._v(" "),
        _c("th", [_vm._v("Identificador")]),
        _vm._v(" "),
        _c("th", [_vm._v("Estado")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { colspan: "7" } }, [
      _c("strong", [_vm._v("No se encontró eventos.")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c927710", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c927710","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/comprobantes/Logs.vue
// module id = 423
// module chunks = 0